<template>
    <div class="kt-portlet">
        <div class="kt-portlet__body" style="color: white; background-color: #8c94b0">
            <h6>{{ $t('dashboard.label.monthly_profit') }}</h6>
            <div class="text-center"><h2 class="fix-margin">{{ profit.monthly }} <span style="font-size: 1.5rem">{{' ' + $t('currency.rial')}}</span></h2></div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "monthly_profit",

        props: {
            profit: {
                default() {
                    return {}
                }
            },
        },
    }
</script>

<style scoped>

</style>